import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiError } from 'app/core/errors/api-error';
import {
  IModalSettings,
  ModalComponent,
} from 'app/domains/shared/components/modal/modal.component';
import { ToastService } from 'app/domains/shared/components/toast/services/toast.service';
import { UsuarioApi } from '../../apis/usuario.api';
import { IUsuarioReativarRequest } from '../../interfaces/usuario-reativar-request.interface';
import { UsuarioCrudHttpService } from '../../services/usuario-crud-http.service';
import { Usuario } from '../../usuario';

@Component({
  selector: 'sgt-form-reativar-usuario-modal',
  templateUrl: './form-reativar-usuario.modal.html',
})
export class FormReativarUsuarioModal implements OnInit, AfterViewInit {
  /** ID do usuário a ser reativado */
  idUsuario: number | null;
  /** Usuário a ser reativado */
  usuario: Usuario | null;

  // Modal settings
  title = 'Reativar Usuário';
  confirmText = 'Reativar';
  cancelText = 'Cancelar';
  settings: IModalSettings = {
    width: '550px',
    allowClickOutsideToClose: false,
    position: 'right',
    hasFooter: true,
  };

  form = new FormGroup({
    justificativa: new FormControl('', [Validators.required, Validators.minLength(15)])
  });

  @ViewChild(ModalComponent) modalRef: ModalComponent;
  @ViewChild('justificativaTextarea') justificativaTextarea: ElementRef<HTMLTextAreaElement>;

  @Output() closed = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<void>();

  constructor(
    private usuarioApi: UsuarioApi,
    private usuarioCrudHttpService: UsuarioCrudHttpService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    if (this.idUsuario) {
      this.fetchUsuario();
    }
  }

  /* Carrega os dados do usuário */
  private fetchUsuario() {
    this.usuarioCrudHttpService.find(this.idUsuario)
        .subscribe({
          next: (usuario) => {
            if (!usuario) {
              this.closeModal();
              return;
            }

            this.usuario = usuario;
          },
          error: (err: ApiError) => {
            this.toastService.error(
              err.message || 'Erro ao buscar dados do usuário.',
              {
                title: err.cause || 'Aconteceu algo inesperado.',
                duration: 5000,
              }
            );
          },
        });
  }

  ngAfterViewInit() {
    if (this.modalRef) {
      setTimeout(() => {
        this.modalRef.open();
        setTimeout(() => this.justificativaTextarea.nativeElement.focus(), 200);
      }, 0);
      this.modalRef.closed.subscribe((result: boolean) => {
        this.closed.emit(result);
      });
    }
  }

  /** Realiza a reativação do usuário */
  submitForm() {
    if (this.form.invalid) {
      return;
    }

    // Criando o payload para reativação
    const payload: IUsuarioReativarRequest = {
      justificativa: this.form.value.justificativa || '',
    };

    // Reativando o usuário
    this.usuarioApi.reativar(this.idUsuario!, payload)
      .subscribe({
        next: () => {
          setTimeout(() => {
            this.toastService.success('Usuário reativado com sucesso.');
          });

          this.confirm();
        },
        error: (error: ApiError) => {
          this.toastService.error(
            error.message || 'Erro ao reativar usuário.',
            {
              title: error.cause || 'Aconteceu algo inesperado.',
              duration: 10000,
            }
          );
        }
      });
  }

  /** Confirma a ação de reativação */
  private confirm() {
    if (this.modalRef) {
      this.modalRef.onConfirm();
      this.confirmed.emit();
    }
    this.closeModal();
  }

  /** Fecha a modal */
  public closeModal() {
    if (this.modalRef) {
      this.modalRef.onClose();
    }
  }
}
